<div class="quantity-controls__quantity">
  <button type="button" [disabled]="decrementDisabled" aria-label="Decrement" (click)="decrementCurrentCount()">&minus;</button>
  <button type="button" aria-label="Quantity" class="quantity">{{ currentCount }}</button>
  <button type="button" [disabled]="incremementDisabled" aria-label="Increment" (click)="incrementCurrentCount()">&plus;</button>
</div>
